$(document).ready(function(){
  

  /************ To display submenu on hover **************/
  $('.site-nav--has-dropdown').hover(function() {

  if ($(this).hasClass('activated')){
    $(this).removeClass('activated');
    $(this).children('.site-nav__dropdown').css('display', 'none');
  }
  else{
    $(this).addClass('activated');
    $(this).children('.site-nav__dropdown').css('display', 'block');
  }  
    
});

  $('.has-child').hover(function() {
    $(this).toggleClass('currently-active');
  }                     
  );
  
  /************ To make header sticky *********/
  
 $(window).scroll(function(){
    if ($(window).scrollTop() >= 300) {
        $('.bottom-header').addClass('fixed-header');
    }
    else {
        $('.bottom-header').removeClass('fixed-header');
    }
});
  
  /************* Home collection tab ***************/
   $('ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
  
 /*************** Mini cart ***********/ 
  	$.ajax({
    type: 'GET',
    url: '/cart.js',
    async: false,
    cache: false,
    dataType: 'json',
    success: function(res){
     // console.log("res:"+res);
	var items = res['items'];
    var count = res['item_count'];
      //console.log(count);
    var total_price= res['original_total_price'];
	//$(".cart_drawer .item_count span").append(count);
        var final_price = parseFloat(total_price / 100).toFixed(2);
      $(".cart_drawer .cart_drawer_items").empty();   
      $('.cart-link__bubble').empty(); 
       if(count == 1){
      $('.item-incart').html("There is <a href='/cart'>"+count+ " item</a> in your basket");
    }
      else{
    $('.item-incart').html("There are <a href='/cart'>"+count+ " items</a> in your basket");
    }
      $('.item-grand-total').html("Basket Subtotal: &pound;"+ final_price); 
	for(i=0;i<items.length;i++){
      var id = items[i]['id'];
      
      var cart_product_type = items[i]['product_type'];
        //console.log(cart_product_type);
      
//      $(".cart_drawer .cart_total_price").html("Total: $"+final_price);
    $(".cart_drawer .cart_drawer_items").append("<div class='cart__row'>"+"<div class='cart__row--table-large'>"+"<div class='action-cart'><a class='edit-product' href="+items[i]['url']+"> <i class='fa fa-pencil' aria-hidden='true'></i></a> <span class='remove-item' data-id="+id+" count-pro="+i+">x</span></div><div class='pro-cart'><div class='img-cart'>"+"<a class='cart__image' href="+items[i]['url']+">"+"<img src="+items[i]['image']+">"+"</a>"+"</div>"+"<div class='meta-cart hover-detail'>"+"<a class='cart__product-name' href="+items[i]['url']+">"+items[i]['title']+"</a>"+" <div class='cart-prices cart-flex'>"+"<div class='item-qubtity-hover'>"+items[i]['quantity']+" x </div>"+""+"<span class='cart__price'>&pound; "+parseFloat(items[i]['price']/100).toFixed(2)+"</span>"+"</div></div>"+"</div>"+"</div>"+"</div>");
      $(".quickCourse .display-blo .cart__row .cart__row--last").addClass("display-all-block");
    $(".quickCourse.display-blo .cart__row.display-no").addClass("display-no-on-ajax");
  if(cart_product_type == 'mw_hidden_cart_fee' ){
      		$('.action-cart').css('display','none');
            $('.cart__product-name,.cart__image').css('cursor','default');
    		$('.cart__image img').attr('src','https://cdn.shopify.com/s/files/1/0283/4268/1699/files/ezgif.com-webp-to-jpg_21.jpg?v=1577361106');
    $('.cart__product-name, .cart__image').on("click", function (e) {
        e.preventDefault();
    });

      }
    }
      $(".cart_drawer .cart_total_price").html("Subtotal: &pound;"+final_price);
            $(".quickCourse.display-blo .cart__row.cart__row--last ").addClass("display-no-on-ajax");
      $("#CartCount span").text(count);
      $('.cart-total').html("&pound;"+final_price);
      if(count > 0 ){
      	$('.empty_cart').css('display','none');
        $('.item-incart').css('display','block');
        $('.item-grand-total').css('display','block');
        $('.custom-checkout').css('display','block');
            }
      else{
      		$('.empty_cart').css('display','block');
        $('.item-incart').css('display','none');
        $('.item-grand-total').css('display','none');
        $('.custom-checkout').css('display','none');
      }       
    }
  });
     
  
  /*************** Collection Sidebar ***************/
   $(".slide-button").on('click', function(){
    var panelId = $(this).attr('data-content');
    $('#'+panelId).toggle(500);

    $(this).find('.panel-icon').text(function(_, txt) {
        return txt === "+" ? "-" : "+";
    });
});
  
  


  });



$(document).on('click','.cart__remove .text-link--accent',function(){

  			var cart_page_title = $(this).parent().parent().find(".cart__product-title").text();
              $(".pro-cart").each(function() {
              var var_cart_title= $(this).parent().find('.cart__product-name').text();
            if(cart_page_title==var_cart_title)
            {
              $(this).parent().parent().find('.remove-item').click();
            }

          });
});
  
  
$(document).on('click','.remove-item',function(e){
  
  	var current_item_id = $(this).attr('data-id');
//      Remove on click pop up cart jquery
      
     
 
//     if(confirm("Are you sure you would like to remove this item ?")){
  
      var cart_title = $(this).parent().parent().find(".cart__product-name").text(); 
          $(".cart__product-information").each(function() {
          var var_title= $(this).parent().find('.cart__product-title').text();
        if(var_title==cart_title)
        {
          $(this).parent().parent().find('.cart__remove a').click();
        }

      });
      
      
      
      
//      Remove on click cart page remove jquery      
    
//   var value_cart = $(this).attr("click_data");
// $('.remove-item')[value_cart].click();

      
      
      
       $('.remove-item').each(function(){
  var remove_item_id = $(this).attr('data-id');
    if(remove_item_id == current_item_id){
    $(this).parent().parent().parent().hide();
    }
    
  });
  	var remove_item_id = $(this).attr('data-id');
    var qty = 0;
    $(this).parent().parent().hide();
    var changeData = {
        id:remove_item_id, 
        quantity:qty
  	  };
    
      $.ajax({
            type: 'post',
            url: '/cart/change.js',
            data: changeData,
            success: function(d){
              
               var count = d['item_count'];
              var total_price= d['original_total_price'];
               var final_price = parseFloat(total_price / 100).toFixed(2);
              $(".cart_drawer .cart_total_price").empty();
               $(".cart_drawer .cart_total_price").html("Subtotal: &pound;"+final_price);
            	$("#CartCount span").text(count);
              $('.cart-subtotal__price .money').html("&pound;"+final_price);
              var final_pri_hide = $('.cart-total').html("&pound;"+final_price);
              $('.item-incart').html("There are <a href='/cart'>"+count+ " items</a> in your basket");
              $('.item-grand-total').html("Basket Subtotal: &pound;"+ final_price); 
              $('.top-count').html(count);
              if(count > 0 ){
      	$('.empty_cart').css('display','none');
                 $('.item-incart').css('display','block');
                 $('.item-grand-total').css('display','block');
                $('.custom-checkout').css('display','block');
            }
      else{
        	$(".shopify-section .page-width .emtry_cart_con").addClass("hide");
        	$('.empty-page-content').removeClass( "hide" );
      		$('.empty_cart').css('display','block');
            $('.item-incart').css('display','none');
        	$('.item-grand-total').css('display','none');
       		$('.custom-checkout').css('display','none');
      } 
              
             
            },
            dataType: 'json'
          });
      
      
//        var value = jQuery(this).attr("count-pro");
//  			  $('.cart__product-information .cart__remove .text-link--accent')[value].click();
//   }
 
    
  });

/********* Cart attributes validation *************/
jQuery(function() {
  jQuery('body').on('click', '[name="checkout"]', function() {
    var formIsValid = true;
    var message = "Please fill out the required information and you will be able to checkout.";
    jQuery('.cart-attribute__field :input[name^="attributes"]:not(:button), [name="note"]').filter('.rquired, [required="required"]').each(function() {
      jQuery(this).removeClass('error');
      if (formIsValid && !jQuery(this).val()) {
        formIsValid = false;
        message = jQuery(this).attr('data-error') || message;
        jQuery(this).addClass('error');
      }
    });
    if (formIsValid){
      jQuery(this).submit();
    }
    else {
      alert(message);
      return false;
    }
    
     if ($('#agree').is(':checked')) {
        $(this).submit();
      }
      else {
        alert("Please agree with the terms and conditions to check out.");
        return false;
      }
    
  });
});





/***************** To send Custom property *********
$(document).on('click','.product-form__cart-submit',function(e){

var title = $(this).attr('product-title');         
   var variant_id_custom = $('#ProductSelect-product-template option:selected').val();
	var qtyminus = $('#Quantity-product-template').val();
  var addData = {
      quantity: qtyminus,
      id: variant_id_custom,
      properties: {
        'Show': title
      }
    }
  


  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: addData,
    success: function(respp){
      console.log(respp);
   $.ajax({
    type: 'GET',
    url: '/cart.js',
    async: false,
    cache: false,
    dataType: 'json',

    success: function(res){
    }
  });
       
  }
  });
});
    **/